<i18n src="../../locales/lang.json"></i18n>

<template>
  <div v-bind:class="{'card-group-control card-group-control-left':enabled}" class="p-0 m-0" v-bind:id="'accordion-control' + getId()" style="width:100%; float:left; display:contents">
    <div class="card shadow-0 border-0 p-0 m-0">
      <div class="card-header px-2 pt-0 pr-0" v-if="enabled == true">
        <h6 class="card-title px-0" style="display:flex;">
          <a data-toggle="collapse" class="text-default" v-bind:href="'#accordion-control' + getId()  + '-group1'"></a>
          <input class="form-control form-control-lg p-1 col-8 col-md-9" @input="input" v-bind:placeholder="$t('section_title')" type="text" v-model="el.Text" style="float:left;width:175px" />
        </h6>
      </div>
      <div v-bind:id="'accordion-control' + getId() + '-group1'" class="p-0 m-0" v-bind:class="{ show: show == 'true' && enabled == true}" v-bind:data-parent="'#accordion-control' + getId()">
        
        <div class="card-body mouseoverexpand p-0 m-0" v-bind:class="{'expand-border item-dopzone' : enabled}">
          <span v-if="enabled" class="drop-container" style="left:16px;"></span>
          <slot></slot>
          <span v-if="enabled" class="drop-container" style="right:-16px;"></span>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'procedure-expand',
    components: {
    },
    props: {
      el: {
        required: false,
        type: Object,
        default: {Text: ''}
      },
      title: {
        required: false,
        type: String,
        default: null
      },
      show: {
        required: false,
        type: String,
        default: 'false'
      },
      enabled: {
        required: false,
        type: Boolean,
        default: false
      }
    },
    methods: {
      input(event) {
        this.el.Text = event.target.value;
      },
      getId() {
        return this._uid;
      }
    },
    created() {
    },
    mounted() {
    }
  }
</script>


<style scoped>

  .drop-container {
    margin-top: -10px;
    min-height: 50px;
    height: 100px;
    /*border: 1px solid red;*/
    height: calc(100% + 20px)
  }

  .item-dopzone {
    
    margin:auto !important;
    overflow:visible;
  }

  .item-container {
    display:none;
  }

    .item-container.active-drop {
      display: block;
      min-height: 50px !important;
    }


  .mouseoverexpand .item-container {
    min-height: 10px;
    padding-top: 2px;
    padding-bottom: 2px;
  }

  /*
  .mouseoverexpand .item-container:hover {
    min-height: 40px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .mouseoverexpand:hover {
    min-height: 40px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  */

  .expand-border {
    border-left: 5px solid #cbcccc !important;
    margin-left: 10px !important;
    margin-bottom: 10px;
  }

  .card {
    background-color: initial;
  }

  a {
    color: inherit !important;
  }

  .item-dopzone:hover {
   
    
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-expand.vue